export const proposalConst = {
    questionUnansweredDisplayText: 'Unanswered'
};
